import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { ResultDialogComponent } from '../result-dialog/result-dialog.component';
import { Subscription } from 'rxjs/Subscription';


import { AuthGuardService, CommercialService, UserService } from '@core/services';
import { User } from '@shared/models';

import { fadeAnimation } from '../../app.animations';

@Component({
  selector: 'app-accounts-card-page',
  templateUrl: './accounts-card-page.component.html',
  styleUrls: ['./accounts-card-page.component.css'],
  animations: [fadeAnimation]
})

export class AccountsCardPageComponent implements OnInit, OnDestroy {

  private user: User;
  public isCommercial: any;
  private subscription: Subscription;
  private commercialSubscription: Subscription;
  public programName: string;
  public currency: string;
  public deposit: string;
  public replenishmentAmount: string;
  public tripCost: string;
  private replenishmentThreshold: string;
  private submittedAccount: boolean;
  private submittedCards: boolean;
  private _accountCardInfo: any;
  public programsInfo: any;
  public programTypeId: number;
  public programControl: any;
  public programId: number;
  accountSetup: FormGroup;

  constructor(private _userService: UserService,
    private _fb: FormBuilder,
    private _router: Router,
    private dialog: MatDialog,
    private _authGuard: AuthGuardService,
    private _commercial: CommercialService) {
  }

  ngOnInit() {
    this.accountSetup = this._fb.group({
      programControl: this._fb.group({
        programId: new FormControl(['', Validators.required])
      }),
      currency: this._fb.group({
        ProgramTypeId: new FormControl()
      }),
      CardList: this._fb.array([])
    });

    this.subscription = this._userService.getUser().subscribe(user => this.user = user);
    this.commercialSubscription = this._commercial.getCommercialValue().subscribe(isCommercial => this.isCommercial = isCommercial);
    this.addTollPass();
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
    this.commercialSubscription.unsubscribe();
  }

  addTollPass() {
    const control = <FormArray>this.accountSetup.controls['CardList'];
    const addrCtrl = this.initTollPasses();

    control.push(addrCtrl);
  }

  initTollPasses() {
    console.log('Current User', this.user);
    return this._fb.group({
      PassName: new FormControl(),
      PassTypeId: new FormControl(),
      NumberOfPasses: new FormControl()
    });
  }

  removePass(i: number) {
    const control = <FormArray>this.accountSetup.controls['CardList'];
    control.removeAt(i);
  }

  onSubmit() {
    console.log(this.accountSetup.value.programControl)
    console.log(this.accountSetup.value.programControl.programId)
    console.log(this.accountSetup.value.programControl.programId[0])
    if(this.accountSetup.value.programControl.programId == undefined || this.accountSetup.value.programControl.programId == null || this.accountSetup.value.programControl.programId[0] == '' || this.accountSetup.value.programControl.programId == ''){
      let dialogRef = this.dialog.open(ResultDialogComponent, {
        data: {
          message: 'Please select a program',
          alertType: 'danger',
          title: 'No Program Selected'
        }
      });
      return false
    }
    if (this.submittedAccount) {
      if (this.submittedCards) {
        console.log('Submitted cards already');
        return false;
      } else {
        console.log('Submitted account but not cards', this._accountCardInfo);
        this._accountCardInfo.formData.CardList = this.accountSetup.value.CardList;
        this.submitAccountCards(this._accountCardInfo);
        return false;
      }

    } else if (this.user.accountSummaryArray && this.user.accountSummaryArray.length > 0) {
      this.submitAccountCards(this.setUpUserAccountCards(this.user.accountSummaryArray[this.user.accountIndex].id));
      return false;
    }
    const __ret = this.setUpAccountInfo();
    if (__ret.formData.ProgramTypeId == null) {
      let dialogRef = this.dialog.open(ResultDialogComponent, {
        data: {
          message: 'Please select a currency',
          alertType: 'danger',
          title: 'Failed to create account'
        }
      });
    } else {

      this.submittedAccount = true;
      this._authGuard.authenticatedPost(__ret.insertAccountUrl, __ret.formData).subscribe(
        result => {
          if (!this.isCommercial.isCommercialDomain) {
            this._accountCardInfo = this.setUpAccountCards(result);
            this.submitAccountCards(this._accountCardInfo);
          } else {
            this._router.navigate(['/addcreditcard']);
          }
        },
        error => {
          let dialogRef = this.dialog.open(ResultDialogComponent, {
            data: {
              message: error,
              alertType: 'danger',
              title: 'Failed to create account'
            }
          });
          console.log('Error: ' + error);
          this.submittedAccount = false;
        }
      );
    }
  }

  private submitAccountCards(_accountCardInfo: { formData: { AccountId: any; CardList: (FormArray | any) }; insertCardsUrl: string }) {
    if (this.submittedCards) {
      return false;
    }
    if (this.checkCardCount(_accountCardInfo.formData.CardList)) {
      return false;
    }

    this.submittedCards = true;
    this._authGuard.authenticatedPost(_accountCardInfo.insertCardsUrl, _accountCardInfo.formData).subscribe(
      result => {
        console.log('Successful insertAccountCardsFree', result);
        this._router.navigate(['/addcreditcard']);
      },
      error => {
        console.log('Error: ' + error);

        let dialogRef = this.dialog.open(ResultDialogComponent, {
          data: {
            message: error,
            alertType: 'danger',
            title: 'Failed to add cards'
          }
        });
        this.submittedCards = false;
      }
    );
  }

  private setUpAccountInfo() {
    console.log('Setting account program:' + this.programTypeId);
    const formData = {
      'ProgramTypeId': this.programTypeId,
      'PortfolioId': this.user.customerIdArray[this.user.accountIndex].Id,
      'UserName': this.user.userName,
      'Email': this.user.email
    }
    const insertAccountUrl = 'portfolios/insertaccount';
    return { formData, insertAccountUrl };
  }

  private setUpAccountCards(accountDataReturn) {
    const formData = {
      'AccountId': accountDataReturn[0].web_insert_account,
      'CardList': this.accountSetup.value.CardList
    }
    const insertCardsUrl = 'portfolios/insertaccountcardsfree';
    return { formData, insertCardsUrl };
  }
  private setUpUserAccountCards(userAccount) {
    const formData = {
      'AccountId': userAccount,
      'CardList': this.accountSetup.value.CardList
    }
    const insertCardsUrl = 'portfolios/insertaccountcardsfree';
    return { formData, insertCardsUrl };
  }

  currencyChanged(program) {
    console.log(program)
    console.log(this.programsInfo)
    if(!this.programsInfo){
      let dialogRef = this.dialog.open(ResultDialogComponent, {
        data: {
          message: 'Please select your program first.',
          alertType: 'danger',
          title: 'No Program Selected'
        }
      });
      return;
    }
    this.currency = program.CurrencyType;
    console.log(this.programName)
    this.programsInfo.forEach(element => {
      if (element.Name == this.programName && element.CurrencyType == this.currency){
        console.log(element);
        this.deposit = element.Deposit.toLocaleString('en-US', { style: "currency", currency: "USD" });
        this.replenishmentAmount = element.ReplenishmentAmount.toLocaleString('en-US', { style: "currency", currency: "USD" });

        this.replenishmentThreshold = element.ReplenishmentThreshold.toLocaleString('en-US', { style: "currency", currency: "USD" });

        this.tripCost = element.TripCost;
        console.log('Setting Program to ' + element.Id);
        this.programTypeId = element.Id;
      }
    });
    
  }

  programChanged(element) {
    console.log(element)
    console.log(element.program);
    console.log(element.programInfo);
    console.log(this.currency);
    this.programName = element.program.Name;
    this.programsInfo = element.programInfo;
    this.accountSetup.controls['programControl'].patchValue({programId: element.program.Id})
    this.accountSetup.controls['currency'].patchValue({ProgramTypeId: null})
    
    console.log(this.accountSetup.value.programControl)

    //Check of clear currency selection after 
  }

  checkCardCount(cardList: any) {
    let windshieldCount = 0;
    let nexusCount = 0;
    for (let card of cardList) {
      console.log('checking cards ', card);
      if (card.PassTypeId == 5) {
        windshieldCount += +card.NumberOfPasses;
      } else {
        nexusCount += +card.NumberOfPasses;
      }
    }
    console.log('number of windshield passes: ', windshieldCount);
    console.log('number of nexus passes: ', nexusCount);

    if (windshieldCount > 5 || nexusCount > 2) {
      let dialogRef = this.dialog.open(ResultDialogComponent, {
        data: {
          message: 'Passes are limited to 5 windshield tags and 2 Nexus cards, please correct your order and try again',
          alertType: 'warning',
          title: 'Too Many Cards Selected'
        }
      });
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/accounts-card-page/accounts-card-page.component.ts